<template>
  <div id="lineSetting">
    <div class="head">
      <el-steps :active="step - 1" finish-status="success" simple style="width: 50%; margin: auto; background: #fff">
        <el-step title="设置线路信息" icon="el-icon-cpu"></el-step>
        <el-step title="设置线路票价" icon="el-icon-money"></el-step>
        <el-step title="创建线路完成" icon="el-icon-s-promotion"></el-step>
      </el-steps>
    </div>

    <div class="lineContent" v-show="step == 1">
      <div class="left">
        <el-form :model="form" :rules="rules" ref="line" label-width="80px" label-position="left">
          <div id="start" class="start">
            <h2>设置出发地</h2>

            <div class="places">
              <div v-for="(item, index) in form.stationVoList[0].stationRail" :key="index" :tabindex="index"
                   @click="clickStartItem(item, index)" :class="{ focus: active.place == 0 && active.index == index }"
                   class="places-item" :ref="'startPlaces_' + index">
                <div class="places-item-left">
                  <div class="radios">
                    <span class="index">{{ index + 1 }}</span>
                    <el-radio v-model="item.stationType" :label="1" @change="actionTypeChange(1, 0, item, index)"
                              border>定点接送
                    </el-radio>
                    <el-radio v-model="item.stationType" :label="2" @change="actionTypeChange(2, 0, item, index)"
                              border>上门接送
                    </el-radio>
                  </div>
                  <div>
                    <el-form-item :prop="'stationVoList.0.stationRail.' + index + '.stationName'
                      " :rules="{ required: true, message: `请设置该名称`, trigger: 'blur' }">
                      <el-input v-model="item.stationName" :placeholder="item.stationType == 1
                        ? '设置站点名称，例如成都、四川大学'
                        : '设置围栏名称，例如高新区接送、大学城区域'
                        " maxlength="20">
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="places-item-right">
                  <i class="iconfont icon-delete" v-show="form.stationVoList[0].stationRail.length > 1"
                     @click.stop="deleteStartPlaces(item, index)"></i>
                </div>
              </div>
            </div>

            <div class="buttons">
              <div @click="createdStartItem()">创建下一个</div>
              <div @click="getHistoryPolygons(0)">从历史选择</div>
            </div>
          </div>

          <div class="end">
            <h2>设置目的地</h2>

            <div class="places">
              <div v-for="(item, index) in form.stationVoList[1].stationRail" :key="index" :tabindex="index" :class="{
                focus: active.place == 1 && active.index == index,
              }" class="places-item" :ref="'endPlaces_' + index" @click="clickEndItem(item, index)">
                <div class="places-item-left">
                  <div class="radios">
                    <span class="index">{{ index + 1 }}</span>
                    <el-radio v-model="item.stationType" :label="1" @change="actionTypeChange(1, 1, item, index)"
                              border>定点接送
                    </el-radio>
                    <el-radio v-model="item.stationType" :label="2" @change="actionTypeChange(2, 1, item, index)"
                              border>上门接送
                    </el-radio>
                  </div>
                  <div>
                    <el-form-item :prop="'stationVoList.1.stationRail.' + index + '.stationName'
                      " :rules="{ required: true, message: `请设置该名称`, trigger: 'blur' }">
                      <el-input v-model="item.stationName" :placeholder="item.stationType == 1
                        ? '设置站点名称，例如成都、四川大学'
                        : '设置围栏名称，例如高新区接送、大学城区域'
                        " maxlength="20">
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="places-item-right">
                  <i class="iconfont icon-delete" v-show="form.stationVoList[1].stationRail.length > 1"
                     @click.stop="deleteEndPlaces(item, index)"></i>
                </div>
              </div>
            </div>

            <div class="buttons">
              <div @click="createdEndItem()">创建下一个</div>
              <div @click="getHistoryPolygons(1)">从历史选择</div>
            </div>
          </div>

          <div>
            <el-form-item label="出发地" prop="startStationName">
              <el-input v-model="form.startStationName" placeholder="线路起始地"></el-input>
            </el-form-item>
            <el-form-item label="目的地" prop="endStationName">
              <el-input v-model="form.endStationName" placeholder="线路目的地"></el-input>
            </el-form-item>
            <el-form-item label="机构名称" prop="organizationId">
              <el-select v-model="form.organizationId" :disabled="id ? true : false" @change="organizationIdChange"
                         v-if="mixinUserInfo && mixinUserInfo.organizationType === 1" filterable>
                <el-option v-for="(item, index) in organizations" :key="index" :value="item.id" :label="item.name">
                </el-option>
              </el-select>
              <span v-else>{{
                  organizations && organizations[0] && organizations[0].name
                }}</span>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="display: inline-block; width: 1rem"></span>提成规则</span>
              <el-select v-model="form.commissionConfigId" :disabled="commissionConfigDisabled ||
                (form.organizationId ? false : true)
                " filterable>
                <el-option v-for="(item, index) in commissionConfigList" :key="index" :value="item.value"
                           :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!id">
              <span slot="label">
                <span style="display: inline-block; width: 1rem"></span>返程路线</span>
              <el-switch v-model="form.isReturn" :active-value="1" :inactive-value="2" active-color="#13ce66"
                         inactive-color="#ccc">
              </el-switch>
              <span style="margin-left: 10px; font-size: 12px; color: #ccc">创建一条返程线路</span>
            </el-form-item>

            <el-form-item>
              <span slot="label">
                <span style="display: inline-block; width: 1rem"></span>标签</span>
              <el-select v-model="form.labelId" :disabled="labelDisabled" filterable clearable>
                <el-option v-for="(item, index) in labelList" :key="index" :value="item.id" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-button type="primary" style="width: 100%" @click="goStep(2)">
            下一步
          </el-button>
        </el-form>
      </div>
      <div class="right">
        <div class="buttons mapButtons">
          <div>
            <choose-address :value.sync="paramsHistoryPolygons.searchText" placeholder="在地图上搜索位置"
                            :citycode="cityAdcode"
                            @clickRowFn="clickPoint" style="width: 200px"></choose-address>
          </div>
          <div @click="emptyPolygon">清空内容</div>
          <div @click="clickHollow">挖空围栏</div>
        </div>
        <div id="mapCtx"></div>
      </div>
    </div>

    <div class="feeContent" v-show="step == 2">
      <h2>{{ form.startStationName }} - {{ form.endStationName }}</h2>
      <div class="tips">
        注意：如线路需要用「选座模式」，这里设的票价实为选座加价
      </div>
      <el-form :model="form" ref="feeForm">
        <el-table border :data="form.railFee">
          <el-table-column prop="startRailName" label="出发地" v-slot="{ row }">
            <el-tag effect="plain" :type="row.startStationType == 1 ? '' : 'success'" style="margin-right: 8px">
              {{ row.startStationType == 1 ? "站点" : "围栏" }}
            </el-tag>
            {{ row.startRailName }}
          </el-table-column>
          <el-table-column prop="endRailName" label="目的地" v-slot="{ row }">
            <el-tag effect="plain" :type="row.endStationType == 1 ? '' : 'success'" style="margin-right: 8px">
              {{ row.endStationType == 1 ? "站点" : "围栏" }}
            </el-tag>
            {{ row.endRailName }}
          </el-table-column>
          <el-table-column prop="fee" label="票价(元)" width="100px" v-slot="{ $index, row }">
            <el-form-item :prop="'railFee.' + $index + '.fee'" :rules="{
              required: true,
              message: '请设置票价',
              trigger: 'blur',
            }">
              <el-input v-model="row.fee" style="width: 100%" maxlength="3"
                        @input="row.fee = row.fee.replace(/[^\d]/g, '').replace(/^0/g, '')"/>
            </el-form-item>
          </el-table-column>
        </el-table>
      </el-form>
      <div>
        <div class="buttons">
          <el-button type="primary" style="width: 48%" @click="goStep(1)">上一步</el-button>
          <el-button type="primary" style="width: 48%" @click="save">完成</el-button>
        </div>
      </div>
    </div>

    <el-dialog :title="textType == 1 ? '选择历史站点' : '选择历史围栏'" class="history"
               :visible.sync="historyPolygonVisible"
               width="520px" close-on-click-modal>
      <p>
        保存过的{{ textType == 1 ? "定点接送" : "接送围栏" }}，将自动存入历史
      </p>
      <div class="search">
        <el-input type="text" v-model="paramsHistoryPolygons.stationName"
                  :placeholder="textType == 1 ? '搜索站点名称' : '搜索围栏名称'"/>
        <el-button type="primary" @click="getHistoryPolygons()">搜索</el-button>
      </div>
      <el-table border max-height="500" ref="singleTable" :data="historyPolygons.content" style="width: 100%">
        <el-table-column property="date" :label="textType == 1 ? '站点名称' : '围栏名称'" prop="stationName"
                         width="300">
        </el-table-column>
        <el-table-column align="center" property="date" label="操作">
          <template slot-scope="scope">
            <el-button @click.stop="handleChoose(scope.row)" type="text" size="small"
                       v-if="scope.row.chooseType">选择
            </el-button>
            <el-button v-else type="text" size="small" style="color: #ccc">选择</el-button>
            <el-button @click="handleDelete(scope.row, scope.$index)" type="text" size="small"
                       style="color: red">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="paramsHistoryPolygons.page || 1" :page-size="paramsHistoryPolygons.size"
                     :total="historyPolygons.total" :page-sizes="[20, 30, 40, 60]" @size-change="sizeChangeFn"
                     @current-change="currentChangeFn" layout="total, prev, pager, next"/>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import polygonClipping from "polygon-clipping";
import isPolygonsOverlap from "@/assets/js/polygon";

export default {
  name: "lineSetting",
  data() {
    return {
      id: this.$route.query.id,
      // 起始地点集合
      form: {
        startStationName: null, // 起始城市
        endStationName: null, // 终点城市
        organizationId: null, // 机构名称
        commissionConfigId: null, // 提成规则
        isReturn: 2, // 是否返程 1是 2否
        labelId: null, // 线路标签
        railFee: [], // 地址到地址之间的价格
        stationVoList: [
          // 保存地址的经纬度和名称
          {
            stationRail: [
              {
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
              },
            ],
          },
          {
            stationRail: [
              {
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
              },
            ],
          },
        ],
      },
      railFeeOld: [], // 临时保存价格数据，用于匹配历史价格
      stationVoListSnap: [], // 临时保存地址数据，避免保存失败返回时失去对map的覆盖物引用
      rules: {
        startStationName: [{required: true, message: "请设置起点城市名称"}],
        endStationName: [{required: true, message: "请设置终点城市名称"}],
        organizationId: [{required: true, message: "请选择机构名称"}],
        commissionConfigId: [{required: true, message: "请选择提成规则"}],
        isReturn: [{required: true, message: "请设置返程线路"}],
      },
      // 提成规则集合
      commissionConfigList: [],
      commissionConfigDisabled: false,
      // 分类标签集合
      labelList: [],
      labelDisabled: false,
      // 标签集合
      labels: [],

      // 当前操作的 地址类型：0起点 1终点、地址下标、地图绘制类型
      active: {
        place: 0,
        index: 0,
        actionType: "site", // 站点site ||  绘制draw || 挖空hollow
      },
      // 地图上下文
      mapCtx: null,
      // 鼠标工具
      mouseTool: null,
      polygonColor: {
        startBKGD: "#deefff",
        startBKGDFC: "#0288FF",
        startBD: "#a0d1ff",
        startBDFC: "#68b6ff",
        endBKGD: "#deffe7",
        endBKGDFC: "#40ff02",
        endBD: "#228b2252",
        endBDFC: "#228b2236",
      },
      // 地图当前城市,用于搜索
      cityAdcode: null,
      // 当前页面进度
      step: 1,
      // 历史围栏
      historyPolygonVisible: false,
      paramsHistoryPolygons: {
        page: 1,
        size: 10,
        searchText: null,
        sstationName: null,
        stationType: 1,
      },
      historyPolygons: [],
      chooseIds: [],
      textType: 1,
    };
  },
  computed: {
    // 当前操作的目标地址对象getInfoOverlay
    targetPlace() {
      return this.form.stationVoList[this.active.place].stationRail[this.active.index];
    },
  },
  watch: {
    "form.organizationId"(val) {
      this.getCommissionConfig(val);
    },
  },
  async mounted() {
    this.initMap();
    await this.mixinOrganizations();
    if (
        !this.id &&
        this.mixinUserInfo &&
        this.mixinUserInfo.organizationType === 2
    ) {
      if (
          this.organizations &&
          this.organizations[0] &&
          this.organizations[0].id
      ) {
        this.$set(this.form, "organizationId", this.organizations[0].id);
      }
    }
    this.getlabelList();
  },
  methods: {
    organizationIdChange(val) {
      console.log('organizationIdChange')
      this.form.commissionConfigId = null;
    },
    /* 初始化地图 */
    initMap() {
      this.mapCtx = new AMap.Map("mapCtx", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 15,
        doubleClickZoom: false,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      // 渲染完地图再请求数据
      this.getInfo();

      this.cityAdcode = this.mapCtx.getAdcode();

      // 初始化鼠标工具
      this.mouseTool = new AMap.MouseTool(this.mapCtx);

      // 鼠标绘制完毕事件
      this.mouseTool.on("draw", (e) => {
        this.mouseTool.close(true);
        // obj对象为绘制出来的覆盖物对象。
        this.mapCtx.remove(e.obj);

        // 绘制结果为多边形时
        if (e.obj.CLASS_NAME === "AMap.Polygon") {
          let corners = Array.from(e.obj.getPath(), (value) => [
            value.lng,
            value.lat,
          ]);

          this.handleDraw(corners);
        }
      });

      // 鼠标双击事件
      this.mapCtx.on("dblclick", async (e) => {
        if (this.active.actionType == "site") {
          // 若动作类型为站点 > 则绘制图标
          this.handleDouble(e.lnglat);
        }
      });

      this.placeChange();
    },

    /* 聚焦目标地址变化，覆盖物重新渲染 */
    placeChange() {
      if (this.active.place == 0) {
        // 若当前操作的是起点地址
        this.form.stationVoList[0].stationRail.map((item, index) => {
          // 将所有站点类型的起点覆盖物背景色变浅
          if (item.stationType == 1 && item.marker) {
            // let label = item.marker.getLabel();
            // if (label.content.includes('startFC')) {
            //   label.content = label.content.replace('startFC', 'start')
            // }
            // item.marker.setLabel({
            //   content: label.content,
            //   direction: "top",
            //   offset: new AMap.Pixel(0, -6),
            // });
          } else if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.startBKGD,
              strokeColor: this.polygonColor.startBD,
            });
          }

          // 然后加深目标地址的颜色，移动位置达成聚焦
          if (index == this.active.index) {
            if (item.marker) {
              //   let label = item.marker.getLabel();
              //   label.content = label.content.replace('start', 'startFC')
              //   item.marker.setLabel({
              //     content: label.content,
              //     direction: "top",
              //     offset: new AMap.Pixel(0, -6),
              //   });
              this.mapCtx.setFitView(
                  item.marker,
                  true,
                  [200, 200, 200, 200],
                  17
              );
            } else if (item.polygon) {
              item.polygon.setOptions({
                fillOpacity: 0.3,
                fillColor: this.polygonColor.startBKGDFC,
                strokeColor: this.polygonColor.startBDFC,
              });
              this.mapCtx.setFitView(
                  item.polygon,
                  true,
                  [200, 200, 200, 200],
                  16
              );
            }
          }
        });

        // 其他范围类型的终点颜色也变浅
        this.form.stationVoList[1].stationRail.map((item) => {
          if (item.stationType == 1 && item.marker) {
            // let label = item.marker.getLabel();
            // if (label.content.includes('endFC')) {
            //   label.content = label.content.replace('endFC', 'end')
            // }
            // item.marker.setLabel({
            //   content: label.content,
            //   direction: "top",
            //   offset: new AMap.Pixel(0, -6),
            // });
          } else if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.endBKGD,
              strokeColor: this.polygonColor.endBD,
            });
          }
        });
      } else if (this.active.place == 1) {
        this.form.stationVoList[1].stationRail.map((item, index) => {
          if (item.stationType == 1 && item.marker) {
            // let label = item.marker.getLabel();
            // if (label.content.includes('endFC')) {
            //   label.content = label.content.replace('endFC', 'end')
            // }
            // item.marker.setLabel({
            //   content: label.content,
            //   direction: "top",
            //   offset: new AMap.Pixel(0, -6),
            // });
          } else if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.endBKGD,
              strokeColor: this.polygonColor.endBD,
            });
          }

          // 然后加深目标地址的颜色，移动位置达成聚焦
          if (index == this.active.index) {
            if (item.marker) {
              //   let label = item.marker.getLabel();
              //   label.content = label.content.replace('end', 'endFC')
              //   item.marker.setLabel({
              //     content: label.content,
              //     direction: "top",
              //     offset: new AMap.Pixel(0, -6),
              //   });
              this.mapCtx.setFitView(
                  item.marker,
                  true,
                  [200, 200, 200, 200],
                  17
              );
            } else if (item.polygon) {
              item.polygon.setOptions({
                fillOpacity: 0.3,
                fillColor: this.polygonColor.endBKGDFC,
                strokeColor: this.polygonColor.endBDFC,
              });
              this.mapCtx.setFitView(
                  item.polygon,
                  true,
                  [200, 200, 200, 200],
                  16
              );
            }
          }
        });

        this.form.stationVoList[0].stationRail.map((item) => {
          if (item.stationType == 1 && item.marker) {
            // let label = item.marker.getLabel();
            // if (label.content.includes('startFC')) {
            //   label.content = label.content.replace('startFC', 'start')
            // }
            // item.marker.setLabel({
            //   content: label.content,
            //   direction: "top",
            //   offset: new AMap.Pixel(0, -6),
            // });
          } else if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.startBKGD,
              strokeColor: this.polygonColor.startBD,
            });
          }
        });
      }

      if (this.targetPlace?.stationType == 1) {
        // 若当前地址类型为定点接送 > 则关闭鼠标绘制
        this.mouseTool.close(true);
      } else if (!this.targetPlace?.polygon) {
        this.actionTypeChange();
      }
    },

    /**
     * 绘制类型变化
     * @actionType 点击地址上单选框的回调参数
     * @place      0 起点  1 终点
     * @item       地址    可选
     * @index      下标    可选
     */
    actionTypeChange(actionType, place, item, index) {
      // 给延迟是因为 该事件会冒泡触发 createdStartItem、createdEndItem 导致下标错误出现意外结果
      if (item) {
        this.active = {
          place: place || this.active.place,
          index,
          actionType: new Map([
            [1, "site"],
            [2, "draw"],
            [3, "hollow"],
          ]).get(actionType),
        };
      } else if (actionType) {
        this.active = {
          place: place || this.active.place,
          index: this.active.index,
          actionType: new Map([
            [1, "site"],
            [2, "draw"],
            [3, "hollow"],
          ]).get(actionType),
        };
      }

      if (this.active.actionType == "site") {
        // 若目标地址绘制类型为站点

        if (this.targetPlace.polygon) {
          // 若之前目标地址已有围栏 > 则删除围栏数据
          this.mapCtx.remove(this.targetPlace.polygon);
          this.targetPlace.polygon = null;
        }
      } else if (this.active.actionType == "draw") {
        if (this.targetPlace.marker) {
          // 若之前目标地址已有marker > 则删除marker数据
          this.mapCtx.remove(this.targetPlace.marker);
          this.targetPlace.marker = null;
        }

        // 若目标地址绘制类型为围栏(多边形)
        if (!this.targetPlace.polygon) {
          // 且不存在围栏
          if (this.active.place == 0) {
            this.mouseTool.polygon({
              fillOpacity: 0.3,
              fillColor: this.polygonColor.startBKGDFC,
              strokeColor: this.polygonColor.startBDFC,
            });
          } else {
            this.mouseTool.polygon({
              fillOpacity: 0.3,
              fillColor: this.polygonColor.endBKGDFC,
              strokeColor: this.polygonColor.endBDFC,
            });
          }
        }
        this.targetPlace.stationName = null;
        this.targetPlace.marker = null;
        this.targetPlace.polygon = null;
      } else if (this.active.actionType == "hollow") {
        // 若目标地址绘制类型为挖空(多边形)
        this.mouseTool.polygon({
          fillColor: "gainsboro",
          strokeColor: "#fffffff0",
        });
      }
    },

    /**
     * 处理双击的回调站点
     * @lnglat 点击位置的经纬度
     */
    async handleDouble(lnglat) {
      let resCity = await this.$AMap.AMapReGeo(lnglat);

      if (resCity) {
        let pois = resCity.regeocode.pois;
        pois.sort((a, b) => {
          return a.distance - b.distance;
        });
        let addressComponent = resCity.regeocode.addressComponent;
        let stationName =
            pois && pois[0] && pois[0].name
                ? pois[0].name
                : resCity.regeocode.formatted_address;
        this.targetPlace.stationName = stationName;
        this.targetPlace.stationAddress =
            pois && pois[0] && pois[0].address
                ? pois[0].address
                : resCity.regeocode.formatted_address;
        this.targetPlace.province = addressComponent.province;
        this.targetPlace.city = addressComponent.city;
        this.targetPlace.area = addressComponent.district;
        this.targetPlace.cityCode = addressComponent.citycode;
        this.targetPlace.adCode = addressComponent.adcode;
        this.targetPlace.longitude = lnglat.lng;
        this.targetPlace.latitude = lnglat.lat;

        // 手动校验地址名称
        this.$refs.line.validateField(
            (this.active.place == 0
                ? "stationVoList.0.stationRail."
                : "stationVoList.1.stationRail.") +
            this.active.index +
            ".stationName"
        );

        this.formAddMarker(lnglat, stationName);
      }
    },

    /* 地图搜索-选择地点 */
    async clickPoint(res) {
      let resCity = await this.$AMap.AMapReGeo(res.location);
      if (this.targetPlace?.stationType == 1) {
        if (resCity) {
          let pois = resCity.regeocode.pois;
          pois.sort((a, b) => {
            return a.distance - b.distance;
          });

          let addressComponent = resCity.regeocode.addressComponent;
          this.targetPlace.province = addressComponent.province;
          this.targetPlace.city = addressComponent.city;
          this.targetPlace.area = addressComponent.district;
          this.targetPlace.cityCode = addressComponent.citycode;
          this.targetPlace.adCode = addressComponent.adcode;
        }
        this.targetPlace.stationName = res.name;
        this.targetPlace.stationAddress = res.district;
        this.formAddMarker(res.location, res.name);
        this.paramsHistoryPolygons.searchText = "";
        this.mapCtx.setFitView(
            this.targetPlace.marker,
            true,
            [200, 200, 200, 200],
            17
        );
      } else {
        this.mapCtx.panTo(res.location);
      }
    },

    /**
     * 绘制marker点覆盖物 => form添加站点(Marker)
     * @lnglat       经纬度
     * @stationName  准确地点名称
     */
    formAddMarker(lnglat, stationName) {
      // 生成Marker
      let marker = this.structureMarker(lnglat, stationName);

      if (this.targetPlace.marker) {
        this.mapCtx.remove(this.targetPlace.marker);
        this.targetPlace.marker = null;
      }

      // 添加站点(Marker)
      this.targetPlace.marker = marker;
    },

    /**
     * 处理绘制的多边形
     * @corners   多边形原始角数据
     */
    handleDraw(corners) {
      // 判断这个围栏是否规范,长度大于1说明生成了一个以上的围栏,同时difference函数会补全封闭角,千万别动这行
      corners = polygonClipping.difference([corners]);

      if (corners.length > 1) {
        this.$message.warning("围栏线条禁止相交，请重新绘制");
        this.actionTypeChange();
        return;
      }

      if (this.active.actionType === "draw") {
        this.formAddPolygon(corners);
        this.formAddCityData(corners);
      } else if (this.active.actionType === "hollow") {
        // 原围栏角数据
        let base = this.targetPlace.polygon.getPath();

        // 合并已建设围栏(多边形)的角数据和挖空多边形的角数据，生成新的的角数据
        corners = this.mergeHollow(base, corners);

        // 设置新生成的围栏
        this.targetPlace.polygon.setPath(corners);
      }

      this.placeChange();
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)
     * @corners   多边形原始角数据
     */
    formAddPolygon(corners) {
      // 生成并添加围栏
      this.targetPlace.polygon = this.structurePolygon(corners);
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)的城市信息数据
     * @corners   多边形原始角数据
     * @city      城市数据
     */
    async formAddCityData(corners, resCity = null) {
      if (corners.length > 0) {
        let arr = [];
        if (!Array.isArray(corners[0])) {
          arr = corners[0];
        } else {
          arr = corners[0][0][0];
        }

        let regeo = await this.$AMap.AMapReGeo(arr);
        resCity = regeo.regeocode.addressComponent;

        if (resCity) {
          this.targetPlace.enclosureAddress =
              corners.length > 0 ? JSON.stringify(corners) : "";
          this.targetPlace.province = resCity.province || "";
          this.targetPlace.city = resCity.city || "";
          this.targetPlace.area = resCity.area || "";
          this.targetPlace.cityCode = resCity.citycode || "";
          this.targetPlace.adCode = resCity.adcode || "";
        }
      }
    },

    /**
     * 挖空角数据处理
     * @base      已建设围栏的原始角数据
     * @hollow    挖空多边形的原始角数据
     */
    mergeHollow(base, hollow) {
      let res = null;
      if (
          base[0] &&
          Array.isArray(base[0]) &&
          base[0][0] &&
          Array.isArray(base[0][0]) &&
          base.length > 1
      ) {
        /* 被挖断的围栏处理 */
        let all = [];
        for (let i = 0; i < base.length; i++) {
          let allRes = this.baseData(base[i], []);
          if (isPolygonsOverlap(hollow, allRes)) {
            allRes.push(hollow[0][0]);
            res = polygonClipping.difference(allRes);
          }
          all = [...all, ...res];
        }
        this.formAddCityData(all);
        return all;
      } else {
        /* 一般围栏处理 */
        let allRes = this.baseData(base);
        allRes.push(hollow[0][0]);
        res = polygonClipping.difference(allRes);
        this.formAddCityData(res);
        return res;
      }
    },

    /* 复杂围栏处理,比如一个围栏被挖断 */
    baseData(data, list = []) {
      if (!Array.isArray(data[0])) {
        let lnglat = data.map((val) => [val.lng, val.lat]);
        list.push(lnglat);
      } else {
        for (let i = 0; i < data.length; i++) {
          this.baseData(data[i], list);
        }
      }
      return list;
    },

    /**
     * 原始经纬度生成站点(Marker)
     * @position  经纬度对象
     * @label     Marker标签文字
     */
    structureMarker(position, label) {
      let content = `<div class="markerLabel ${this.active.place == 0 ? "startFC" : "endFC"}">${label}</div>`;
      let Mark = new AMap.Marker({
        map: this.mapCtx, // 地图实例对象
        position: position, // 标记位置
        // anchor: "bottom-center", // 设置锚点方位
        animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
        icon:
            this.active.place == 0
                ? require("@/assets/img/markerBegin.png")
                : require("@/assets/img/markerEnd.png"),
        offset: new AMap.Pixel(-2, 0),
      });
      Mark.setLabel({
        content: content,
        direction: "top",
        offset: new AMap.Pixel(0, -6),
      });
      return Mark;
    },

    /**
     * 原始角数据生成围栏(多边形)
     * @corners   多边形原始角数据
     */
    structurePolygon(corners) {

      let polygon = new AMap.Polygon({
        map: this.mapCtx,
        path: corners,
        fillOpacity: 0.5,
        strokeOpacity: 1,
        fillColor:
            this.active.place == 0
                ? this.polygonColor.startBKGD
                : this.polygonColor.endBKGD,
        strokeColor:
            this.active.place == 0
                ? this.polygonColor.startBDFC
                : this.polygonColor.endBDFC,
      });
      return polygon;
    },

    /* 创建一个起点 */
    createdStartItem(hasNull = false) {
      map: for (const item of this.form.stationVoList[0].stationRail) {
        if (!item.marker && !item.polygon) {
          hasNull = true;
          this.$message.info("请先完善其他起点信息");
          break map;
        }
      }
      if (hasNull) {
        return;
      }
      this.form.stationVoList[0].stationRail.push({
        type: 1,
        stationType: 1,
        stationName: null,
        marker: null,
        polygon: null,
      });
      this.active = {
        place: 0,
        index: this.form.stationVoList[0].stationRail.length - 1,
        actionType: "site",
      };

      this.placeChange();

      // 视图更新后定位到新创建的起点框
      this.$nextTick(() => {
        let createdDom = this.$refs["startPlaces_" + this.active.index];
        this.scrollIntoView(createdDom[0]);
      });
    },

    /* 创建一个终点 */
    createdEndItem(hasNull = false) {
      map: for (const item of this.form.stationVoList[1].stationRail) {
        if (!item.marker && !item.polygon) {
          hasNull = true;
          this.$message.info("请先完善其他终点信息");
          break map;
        }
      }
      if (hasNull) {
        return;
      }

      this.form.stationVoList[1].stationRail.push({
        type: 2,
        stationType: 1,
        stationName: null,
        marker: null,
        polygon: null,
      });
      this.active = {
        place: 1,
        index: this.form.stationVoList[1].stationRail.length - 1,
        actionType: "site",
      };

      this.placeChange();

      // 视图更新后定位到新创建的终点框,且重新渲染覆盖物
      this.$nextTick(() => {
        let createdDom = this.$refs["endPlaces_" + this.active.index];
        this.scrollIntoView(createdDom[0]);
      });
    },

    /* 滚动到dom位置 */
    scrollIntoView(dom) {
      dom.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },

    /**
     * 点击一个起点
     * @item   起点地址对象
     * @index  起点地址下标
     * @action 是否启动鼠标绘画事件
     */
    clickStartItem(item, index) {
      setTimeout(() => {
        // 更新当前行为
        this.active = {
          place: 0,
          index,
          actionType: item.stationType == 1 ? "site" : "draw",
        };
        this.placeChange();
      }, 100);
    },

    /* 点击一个终点 */
    clickEndItem(item, index) {
      setTimeout(() => {
        this.active = {
          place: 1,
          index,
          actionType: item.stationType == 1 ? "site" : "draw",
        };
        this.placeChange();
      }, 100);
    },

    /* 删除一个起点 */
    deleteStartPlaces(item, index) {
      if (item.marker || item.polygon) {
        this.mapCtx.remove(item.marker || item.polygon);
      }
      this.form.stationVoList[0].stationRail.splice(index, 1);
      // 删除form.stationRailFee中该起点的fee数据
      this.form.stationRailFee = this.form.stationRailFee.filter(
          (val) => val.startRailName !== item.stationName
      );
      this.active.index = null;
      let deleteIndex = this.chooseIds.includes(item.historyId);
      if (deleteIndex > -1) {
        this.chooseIds.splice(deleteIndex, 1);
      }
    },

    /* 删除一个终点 */
    deleteEndPlaces(item, index) {
      if (item.marker || item.polygon) {
        this.mapCtx.remove(item.marker || item.polygon);
      }
      this.form.stationVoList[1].stationRail.splice(index, 1);
      // 删除form.stationRailFee中该终点的fee数据
      this.form.stationRailFee = this.form.stationRailFee.filter(
          (val) => val.endRailName !== item.stationName
      );
      this.active.index = null;
      let deleteIndex = this.chooseIds.includes(item.historyId);
      if (deleteIndex > -1) {
        this.chooseIds.splice(deleteIndex, 1);
      }
    },

    /* 清空围栏数据 */
    emptyPolygon() {
      if (!this.targetPlace.polygon) {
        this.$message.info("该地点未设置围栏");
        return;
      }
      this.$confirm(`确定要清空该围栏？`, "提示").then(() => {
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;

        if (this.targetPlace.historyId) {
          this.chooseIds.splice(
              this.chooseIds.findIndex(
                  (val) => val == this.targetPlace.historyId
              ),
              1
          );
        }

        this.actionTypeChange();
      });
    },

    /* 点击挖空 */
    clickHollow() {
      if (this.targetPlace.polygon) {
        this.actionTypeChange(3);
      } else {
        this.$message.info("该地址没有围栏");
      }
    },

    /* 点击下一步 */
    async goStep(step) {
      if (step == 1) {
        this.step = 1;
        this.form.railFee = [];
      } else if (step == 2) {
        this.$refs.line.validate(async (valid) => {
          if (valid) {
            // 验证名称
            let res = await this.$axios.get("/api/v1/manage/line/check", {
              startStationName: this.form.startStationName,
              endStationName: this.form.endStationName,
              isReturn: this.form.isReturn || 2,
              lineId: this.id || null,
            });
            if (res.error) {
              return;
            }
            if (res && res.data) {
              this.$message("存在相同起点/终点城市名称，请重新输入");
              return;
            }

            // 验证所有地址存在覆盖物
            let everyList = [
              ...this.form.stationVoList[0].stationRail,
              ...this.form.stationVoList[1].stationRail,
            ];
            let hasNull = false;
            for (const item of everyList) {
              if (!item.marker && !item.polygon) {
                hasNull = true;
                break;
              }
            }
            if (hasNull) {
              this.$message.info("有地址未设置站点或围栏，请检查");
              return;
            }

            // 赋予 railNo
            for (let [
              index,
              item,
            ] of this.form.stationVoList[0].stationRail.entries()) {
              item.railNo = index + 1;
            }
            for (let [
              index,
              item,
            ] of this.form.stationVoList[1].stationRail.entries()) {
              item.railNo = index + 1;
            }

            // 匹配历史价格
            let getOldFee = (
                startRailNo,
                endRailNo,
                startRailName,
                endRailName
            ) => {
              let fee = null;
              map: for (let item of this.railFeeOld) {
                if (
                    item.startRailNo == startRailNo &&
                    item.endRailNo == endRailNo &&
                    item.startRailName == startRailName &&
                    item.endRailName == endRailName
                ) {
                  fee = item.fee;
                  break map;
                }
              }
              return fee;
            };

            // 起点终点交叉处理函数
            let crossFn = (way, ...arrs) => {
              // 单程交叉 arr1>起点列表  arr2>终点列表
              let oneWay = arrs.reduce((arr1, arr2) => {
                return arr1.flatMap((e) => {
                  return arr2.map((e2) => {
                    return {
                      startStationType: e.stationType,
                      endStationType: e2.stationType,
                      startRailName: e.stationName,
                      endRailName: e2.stationName,
                      startRailNo: e.railNo,
                      endRailNo: e2.railNo,
                      fee: getOldFee(
                          e.railNo,
                          e2.railNo,
                          e.stationName,
                          e2.stationName
                      ),
                    };
                  });
                });
              });

              //   if (way == 1) {
              //     // 返程交叉
              //     let twoWay = arrs.reduce((arr1, arr2) => {
              //       return arr2.flatMap(e => {
              //         return arr1.map(e2 => {
              //           return {
              //             startStationType: e.stationType,
              //             endStationType: e2.stationType,
              //             startRailName: e.stationName,
              //             endRailName: e2.stationName,
              //             startRailNo: e.railNo,
              //             endRailNo: e2.railNo,
              //             fee: getOldFee(e.railNo, e2.railNo, e.stationName, e2.stationName)
              //           }
              //         })
              //       })
              //     })
              //     return oneWay.concat(twoWay);
              //   } else {
              return oneWay;
              //   }
            };
            let railFee = crossFn(
                this.form.isReturn,
                this.form.stationVoList[0].stationRail,
                this.form.stationVoList[1].stationRail
            );
            this.form.railFee = railFee.map((item) => {
              // 找出this.form.stationRailFee中对应的item
              let oldValue = this.form.stationRailFee ? this.form.stationRailFee.find(item2 => {
                return item2.startRailName == item.startRailName && item2.endRailName == item.endRailName
              }) : null;

              return {
                ...oldValue || {},
                ...item,
              }
            })
            this.step = step;
          } else {
            this.$message.info("请先完善线路信息");
          }
        });
      }
    },

    /* 点击保存 */
    save() {
      this.$refs.feeForm.validate(async (valid) => {
        if (valid) {
          // 删除地址中marker和polygon的数据，其中存在循环自我引用，序列化会抛出异常：Converting circular structure to JSON
          //  this.stationVoList = [this.form.stationVoList[0].stationRail, this.form.stationVoList[1].stationRail];

          this.stationVoListSnap = this.form.stationVoList;

          this.form.stationVoList[0].stationRail.map((item) => {
            if (item.marker) {
              let position = item.marker.getPosition();
              [item.longitude, item.latitude] = [position.lng, position.lat];
            }
            delete item.marker;
            delete item.polygon;
          });
          this.form.stationVoList[1].stationRail.map((item) => {
            if (item.marker) {
              let position = item.marker.getPosition();
              [item.longitude, item.latitude] = [position.lng, position.lat];
            }
            delete item.marker;
            delete item.polygon;
          });
          if (this.id) {
            this.putFn();
          } else {
            this.postFn();
          }
        } else {
          this.$message.info("请完善票价信息");
        }
      });
    },

    /* 接口请求-添加 */
    async postFn({...params} = JSON.parse(JSON.stringify(this.form))) {
      this.loading = true;
      let url = "/api/v1/manage/line";

      let [start0, end0] = [
        params.stationVoList[0].stationRail[0],
        params.stationVoList[1].stationRail[0],
      ];
      console.log(end0.city && end0.city.length ? end0.city : end0.province, 323232);
      let stationVoList = [
        {
          type: 1,
          stationType:
              params.stationVoList[0].stationRail.length == 1 &&
              start0.stationType == 1
                  ? 1
                  : 2,
          province: start0.province || "",
          city: start0.city && start0.city.length ? start0.city : start0.province,
          area: start0.area || "",
          cityCode: start0.cityCode || "",
          adCode: start0.adCode || "",
          stationRail: params.stationVoList[0].stationRail.map((item) => {
            return {
              ...item,
              city: item.city && item.city.length ? item.city : item.province,
            }
          }),
        },
        {
          type: 2,
          stationType:
              params.stationVoList[1].stationRail.length == 1 &&
              end0.stationType == 1
                  ? 1
                  : 2,
          province: end0.province || "",
          city: end0.city && end0.city.length ? end0.city : end0.province,
          area: end0.area || "",
          cityCode: end0.cityCode || "",
          adCode: end0.adCode || "",
          stationRail: params.stationVoList[1].stationRail.map((item) => {
            return {
              ...item,
              city: item.city && item.city.length ? item.city : item.province,
            }
          }),
        },
      ];
      params.station = JSON.stringify(stationVoList);
      params.railFee = JSON.stringify(params.railFee);
      delete params.stationVoList;

      let res = await this.$axios.post(url, params);
      if (res && res.code === 1) {
        this.$message.success("添加成功！");

        this.$router.push({
          path: "/schedulingTypeForm",
          query: {lineId: res.data, lineName: this.form.startStationName + ' - ' + this.form.endStationName}
        });
      }
      this.loading = false;
    },

    /* 接口请求-编辑 */
    async putFn({...params} = JSON.parse(JSON.stringify(this.form))) {
      this.loading = true;
      let url = "/api/v1/manage/line";

      let [start0, end0] = [
        params.stationVoList[0].stationRail[0],
        params.stationVoList[1].stationRail[0],
      ];
      let stationVoList = [
        {
          id: params.stationVoList[0].id,
          type: 1,
          stationType:
              params.stationVoList[0].stationRail.length == 1 &&
              start0.stationType == 1
                  ? 1
                  : 2,
          province: start0.province || "",
          city: start0.city && start0.city.length ? start0.city : start0.province,
          area: start0.area || "",
          cityCode: start0.cityCode || "",
          adCode: start0.adCode || "",
          stationRail: params.stationVoList[0].stationRail.map((item) => {
            return {
              ...item,
              city: item.city && item.city.length ? item.city : item.province,
            }
          }),
        },
        {
          id: params.stationVoList[1].id,
          type: 2,
          stationType:
              params.stationVoList[1].stationRail.length == 1 &&
              end0.stationType == 1
                  ? 1
                  : 2,
          province: end0.province || "",
          city: end0.city && end0.city.length ? end0.city : end0.province,
          area: end0.area || "",
          cityCode: end0.cityCode || "",
          adCode: end0.adCode || "",
          stationRail: params.stationVoList[1].stationRail.map((item) => {
            return {
              ...item,
              city: item.city && item.city.length ? item.city : item.province,
            }
          }),
        },
      ];

      params.station = JSON.stringify(stationVoList);
      params.railFee = JSON.stringify(params.railFee);
      delete params.stationVoList;

      let res = await this.$axios.put(url, params);
      if (res && res.code === 1) {
        this.$message.success("修改成功！");
        if (this.form.schedulingType) {
          this.$router.back();
        } else {
          this.$router.push({
            path: "/schedulingTypeForm",
            query: {lineId: res.data, lineName: this.form.startStationName + ' - ' + this.form.endStationName}
          });
        }
      }
      this.loading = false;
    },

    /* 获取线路详情 */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let url = "/api/v1/manage/line/" + this.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.stationVoList) {
        this.railFeeOld = data.data.stationRailFee;
        this.form = {...data.data, railFee: data.data.stationRailFee};
        delete data.data.stationRailFee;
        this.getInfoOverlay();
      }
    },

    /* 获取详情后-覆盖物处理 */
    getInfoOverlay() {
      this.form.stationVoList.map((sr, srIndex) => {
        sr.stationRail.map((item, index) => {
          this.active = {
            place: srIndex,
            index,
            actionType: null,
          };
          if (item.stationType == 1) {
            this.formAddMarker(
                new AMap.LngLat(item.longitude, item.latitude),
                item.stationName
            );
          } else {
            this.formAddPolygon(JSON.parse(item.enclosureAddress));
          }
        });
      });
      this.active = {
        place: 0,
        index: null,
        actionType: null,
      };
      this.mapCtx.setFitView();
      this.placeChange();
    },

    /* 提成规则 */
    async getCommissionConfig(val) {
      let url = "/api/v1/manage/line/commissionConfig";
      let params = {
        organizationId: val,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.commissionConfigList = [
            {
              value: null,
              label: "机构下无提成规则",
              disabled: true,
            },
          ];
          this.commissionConfigDisabled = true;
        } else {
          let commissionConfigList = data.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          });
          this.commissionConfigList = [
            {
              value: null,
              label: "无提成规则",
            },
            ...commissionConfigList,
          ];
          this.commissionConfigDisabled = false;
        }
      }
    },

    /* 分类标签 */
    async getlabelList() {
      let url = "/api/v1/manage/lineLabel/labelList";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.labelList = [
            {
              value: null,
              label: "未配置标签，无标签可选",
              disabled: true,
            },
          ];
          this.labelDisabled = true;
        } else {
          this.labelList = data.data;
          this.labelDisabled = false;
        }
      }
    },

    /* 历史围栏页码改变的回调，返回改变后的页码 */
    sizeChangeFn(val) {
      this.paramsHistoryPolygons.size = val;
      this.getHistoryPolygons();
    },
    /* 切换每页条数时的回调，返回切换后的每页条数 */
    currentChangeFn(val) {
      this.paramsHistoryPolygons.page = val;
      this.getHistoryPolygons();
    },

    /* 获取历史围栏数据 */
    async getHistoryPolygons(place = null) {

      if (place !== null && this.active.index !== null) {
        this.active.place = place;
        this.active.index =
            this.form.stationVoList[place].stationRail.length - 1;
      }
      if (this.active.index === null) {
        this.$message("请先选中一个地址");
        return;
      }
      if (this.targetPlace.marker || this.targetPlace.polygon) {
        this.$message("该地址已有站点/围栏数据");
        return;
      }
      this.loading = true;
      let url = "/api/v1/manage/line/stationRail/history";
      this.paramsHistoryPolygons.stationType = this.targetPlace.stationType;
      let data = await this.$axios.get(url, this.paramsHistoryPolygons);
      if (data.data.length === 0) {
        this.$message.info(
            `无历史${this.targetPlace.stationType == 1 ? "站点" : "围栏"}数据，请创建新${this.targetPlace.stationType == 1 ? "站点" : "围栏"}`
        );
        this.historyPolygons = {
          content: [],
          total: 0,
        };
      } else {
        this.historyPolygonVisible = true;
        this.textType = this.targetPlace.stationType;
        if (this.active.place === 0) {
          if (this.chooseIds.length == 0) {
            data.data.map((val) => {
              val.chooseType = true;
            });
          } else {
            data.data.map((val) => {
              val.chooseType = true;
              this.chooseIds.map((id) => {
                if (id == val.id) {
                  val.chooseType = false;
                  return;
                }
              });
            });
          }
        } else {
          if (this.chooseIds.length == 0) {
            data.data.map((val) => {
              val.chooseType = true;
            });
          } else {
            data.data.map((val) => {
              val.chooseType = true;
              this.chooseIds.forEach((id) => {
                if (id == val.id) {
                  val.chooseType = false;
                  return;
                }
              });
            });
          }
        }

        if (data) {
          this.historyPolygons = {
            content: data.data,
            total: data.total,
          };
        }
        this.loading = false;
      }
    },

    /* 选择一个历史站点/围栏 */
    handleChoose(row) {
      if (this.targetPlace.stationType == 1) {
        this.formAddMarker(
            new AMap.LngLat(row.longitude, row.latitude),
            row.stationName
        );
        this.mapCtx.setFitView(
            this.targetPlace.marker,
            true,
            [200, 200, 200, 200],
            17
        );
      } else {
        this.mouseTool.close(true);
        this.formAddPolygon(JSON.parse(row.enclosureAddress));
        this.targetPlace.enclosureAddress = row.enclosureAddress;
        this.mapCtx.setFitView(
            this.targetPlace.polygon,
            true,
            [200, 200, 200, 200],
            16
        );
      }

      [
        this.targetPlace.stationName,
        this.targetPlace.stationAddress,
        this.targetPlace.province,
        this.targetPlace.city,
        this.targetPlace.cityCode,
        this.targetPlace.area,
        this.targetPlace.adCode,
        this.targetPlace.historyId,
      ] = [
        row.stationName,
        row.stationAddress,
        row.province,
        row.city,
        row.cityCode,
        row.area,
        row.adCode,
        row.id,
      ];

      this.chooseIds.push(row.id);
      this.historyPolygonVisible = false;
    },

    /* 删除历史围栏 */
    handleDelete(row) {
      this.$confirm(`确认删除吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.loading = true;
        let url = "/api/v1/manage/line/stationRail/history/" + row.id;
        let data = await this.$axios.delete(url);
        if (data && data.code === 1) {
          this.$message.success("已删除");
          this.getHistoryPolygons();
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#lineSetting {
  height: 100%;
  box-sizing: border-box;

  .head {
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 2rem;
    background: #fff;
    padding: 20px 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    i {
      margin: 0 1rem;
    }
    
    /deep/ .el-steps {
      .el-step__title {
        font-size: 14px;
        font-weight: 500;
      }
      
      .el-step__icon {
        width: 28px;
        height: 28px;
      }
    }
  }

  .lineContent {
    height: calc(100% - 7rem);
    display: flex;
    gap: 16px;

    .left {
      box-sizing: border-box;
      width: 22%;
      min-width: 320px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      h2 {
        line-height: 1;
        text-indent: 1rem;
        border-left: 4px solid #2B77FF;
        margin-bottom: 1.5rem;
        font-size: 15px;
        font-weight: 600;
        color: #303133;
      }

      /deep/ .el-form {
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        margin: 0;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 4px !important;
          background-color: transparent !important;
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: #dcdfe6;
          border-radius: 4px;
        }
        
        .el-form-item__label {
          font-weight: 500;
          color: #606266;
        }
        
        .el-input__inner {
          border-radius: 6px;
        }
        
        .el-select {
          width: 100%;
        }
        
        .el-button--primary {
          border-radius: 6px;
          font-weight: 500;
        }
      }

      .start {
        margin-bottom: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px dashed #ebeef5;
      }

      .end {
        margin-bottom: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px dashed #ebeef5;

        h2 {
          border-color: #67C23A;
        }

        .places-item.focus {
          background-color: #f0f9eb;
          box-shadow: 0 0 0 2px rgba(103, 194, 58, 0.3);
          border-color: #67C23A;
        }
      }

      .places {
        &-item {
          padding: 16px;
          width: 100%;
          border: 1px solid #e4e7ed;
          border-radius: 8px;
          box-sizing: border-box;
          margin-bottom: 12px;
          transition: all 0.2s ease;
          display: flex;
          background: #fafbfc;

          &.focus {
            background-color: #f0f7ff;
            box-shadow: 0 0 0 2px rgba(43, 119, 255, 0.3);
            border-color: #2B77FF;
          }

          &:nth-last-child(1) {
            margin-bottom: 0;
          }
          
          &:hover:not(.focus) {
            border-color: #c0c4cc;
            background: #fff;
          }

          &-left {
            flex-grow: 1;

            /deep/ .el-form-item__content {
              margin-left: 0 !important;
            }

            .radios {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;

              .index {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 28px;
                height: 28px;
                font-size: 13px;
                font-weight: 600;
                border: 1px solid #dcdfe6;
                border-radius: 50%;
                background: #fff;
                color: #606266;
              }

              .el-radio {
                background-color: white;
                margin: 0;
                margin-left: 8px;
                flex-grow: 1;
                border-radius: 6px;
                
                &.is-bordered.is-checked {
                  border-color: #2B77FF;
                }
              }
            }
          }

          &-right {
            width: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              color: #c0c4cc;
              cursor: pointer;
              font-size: 16px;
              transition: all 0.2s ease;
              padding: 4px;
              border-radius: 4px;

              &:hover {
                color: #F56C6C;
                background: #fef0f0;
              }
            }
          }

          /deep/ .el-form-item {
            margin-bottom: 0;

            .el-input__inner {
              padding: 0 12px;
              border-radius: 6px;
            }

            .el-form-item__error {
              margin: 4px 0 0 0;
              font-size: 12px;
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      box-sizing: border-box;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      #mapCtx {
        width: 100%;
        height: 100%;
      }

      // /deep/ .amap-maps {
      //   &::after {
      //     width: 100%;
      //     height: 100%;
      //     content: " ";
      //     box-shadow: inset 0 0 10px 5px white;
      //     position: absolute;
      //     top: 0;
      //     left: 0;
      //     z-index: 1;
      //   }
      // }
      /deep/ .markerLabel {
        padding: 1rem 1.5rem;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 1.5rem;
        color: #ffffff;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

        &.start {
          background-color: #0289ffbb;
        }

        &.startFC {
          background-color: #0289ff;
        }

        &.end {
          background-color: #228b22bb;
        }

        &.endFC {
          background-color: #228b22;
        }
      }
    }
  }

  .feeContent {
    height: calc(100% - 5rem);
    width: 60%;
    margin: 0 auto;

    h2 {
      margin: 5rem 0;
      width: 100%;
      text-align: center;
    }

    .tips {
      color: #999;
    }

    .el-form-item {
      margin: 0;
    }
  }

  .is-error {
    .el-input__inner {
      border: 1px #ff8252 solid;
    }

    .el-form-item__error {
      color: #ff8252;
    }
  }

  .buttons {
    height: auto;
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    div {
      flex: 1;
      line-height: 36px;
      text-align: center;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 13px;
      color: #606266;
      background: #fff;
      transition: all 0.2s ease;

      &:hover {
        border-color: #2B77FF;
        color: #2B77FF;
        background: #f0f7ff;
      }
    }

    &.mapButtons {
      width: auto;
      max-width: 60%;
      padding: 16px 20px;
      margin: 0;
      background-color: white;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      border-radius: 0 8px 0 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      & > div {
        cursor: pointer;
        min-width: 100px;
      }

      /deep/ div:nth-child(1) {
        border: none;
        background: transparent;

        #chooseAddress,
        .area-input {
          width: 100% !important;
        }

        .close-btn {
          top: 0 !important;
        }

        .map-show {
          min-width: 350px;
          max-width: 50%;
          top: 135%;
          left: -20px;
          padding: 16px 20px 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

          .icon {
            background: url("../../../assets/img/markerBegin.png") no-repeat;
            font-size: 0;
            position: relative;
            top: 5px;
          }

          .val {
            text-align: left;
          }
        }
      }
    }
  }

  .search {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px;
    gap: 12px;

    .el-input {
      flex: 1;
      
      .el-input__inner {
        border-radius: 6px;
      }
    }
    
    .el-button {
      border-radius: 6px;
    }
  }
  
  .feeContent {
    height: calc(100% - 5rem);
    width: 60%;
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    h2 {
      margin: 3rem 0 2rem;
      width: 100%;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }

    .tips {
      color: #909399;
      font-size: 13px;
      margin-bottom: 16px;
    }

    .el-form-item {
      margin: 0;
    }
  }

  .is-error {
    .el-input__inner {
      border: 1px #F56C6C solid;
    }

    .el-form-item__error {
      color: #F56C6C;
    }
  }
}
</style>
